var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('AppToolbar'),_c('v-main',[_c('v-container',{staticClass:"pa-0",attrs:{"fluid":""}},[_c('v-row',{attrs:{"no-gutters":"","justify":"center"}},[_c('v-col',{attrs:{"cols":"12"}},[_c('v-slide-y-reverse-transition',{attrs:{"mode":"out-in"}},[_c('router-view')],1)],1)],1)],1)],1),_c('AppFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }